import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { toNumber, get } from 'lodash-es';
import { humanizeDurationnHoursMinutes } from '../../utils/misc';
import { localDate } from '../../utils/misc';
import moment from 'moment';

import JpLongLogo from '../../assets/companyLogo/jplogo.png';

import { Image } from 'antd';
import 'antd/lib/image/style/index.css';

import { useHostChargingSessionDetails } from '../../utils/queries/hostQueries';
import ChargerOnMap from 'components/Charger/ChargerOnMap';

const useStyles = createUseStyles({
  modal: {
    '& .modal-content': {
      width: '550px',
    },
    '& .modal-title': {
      fontSize: '17px',
    },
  },
  dataRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rowKey: {
    fontWeight: 400,
    marginBottom: '0px',
    color: '#8898aa',
    fontSize: '15px',
  },
  rowValue: {
    fontSize: '15px',
    fontWeight: 500,
    color: '#4f4f4f',
    marginBottom: '0px',
    overflow: 'hidden',
    textOverflow: 'clip',
  },
  brandLogo: {
    width: '85px !important',
    height: '18px !important',
    textAlign: 'center',
  },
});

export default function ChargerSessionModal({
  toggleModalOpen,
  modalOpen,
  cpid,
  transactionId,
}) {
  const classes = useStyles();

  const {
    data: selectedSession,
    // eslint-disable-next-line no-unused-vars
    error,
    isLoading,
  } = useHostChargingSessionDetails(transactionId);

  function getDuration() {
    return moment
      .duration(
        new Date(get(selectedSession, 'END_TIME')) -
          new Date(get(selectedSession, 'START_TIME')),
      )
      .asMinutes();
  }

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModalOpen}
      className={classes.modal}
    >
      <ModalHeader
        toggle={toggleModalOpen}
        style={{ padding: '5px 10px' }}
      ></ModalHeader>

      <ModalBody style={{ paddingTop: '0px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: 5,
          }}
        >
          <div>Charging Session #{get(selectedSession, 'TRANSACTIONID')}</div>
          <ChargerOnMap
            cpid={null}
            longitude={selectedSession?.LONGITUDE}
            latitude={selectedSession?.LATITUDE}
            mapHeight={100}
            mapWidth={100}
            zoomLevel={20}
          />
        </div>
        {isLoading || !selectedSession ? (
          <div
            style={{
              display: 'flex',
              height: '200px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spinner
              style={{
                color: '#2675b8',
                fontSize: '16px',
                height: '40px',
                width: '40px',
              }}
            />
          </div>
        ) : (
          <>
            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Transaction Id</p>
              <p className={classes.rowValue}>
                {get(selectedSession, 'TRANSACTIONID')}
              </p>
            </div>
            <hr style={{ marginTop: '5px', marginBottom: '5px' }} />

            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Charger Id</p>
              <p className={classes.rowValue}>{get(selectedSession, 'CPID')}</p>
            </div>

            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Address</p>
              <p className={classes.rowValue} style={{ marginLeft: 100 }}>
                {get(selectedSession, 'ADDRESS')}
              </p>
            </div>
            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Connector Id</p>
              <p className={classes.rowValue}>
                {get(selectedSession, 'CONNECTORID')}
              </p>
            </div>

            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Starting Meter Reading (in wH)</p>
              <p className={classes.rowValue}>
                {get(selectedSession, 'METER_START')} wH
              </p>
            </div>

            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Stopping Meter Reading (in wH)</p>
              <p className={classes.rowValue}>
                {get(selectedSession, 'METER_STOP')} wH
              </p>
            </div>

            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Units consumed (in kWh)</p>
              <p className={classes.rowValue}>
                {toNumber(selectedSession.KWH_BILLED).toFixed(2)} KWH
              </p>
            </div>

            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Tariff</p>
              <p className={classes.rowValue}>
                ₹ {toNumber(get(selectedSession, 'BASE_KWH_COST')).toFixed(2)}
              </p>
            </div>

            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Charging started at</p>
              <p className={classes.rowValue}>
                {localDate(selectedSession.START_TIME)}
              </p>
            </div>

            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Charging ended at</p>
              <p className={classes.rowValue}>
                {localDate(selectedSession.END_TIME)}
              </p>
            </div>

            <div className={classes.dataRow}>
              <p className={classes.rowKey}>Duration</p>
              <p className={classes.rowValue}>
                {humanizeDurationnHoursMinutes(getDuration()).string}
              </p>
            </div>

            {selectedSession.LIMIT_TYPE !== '0' ? (
              <>
                <hr style={{ marginTop: '5px', marginBottom: '5px' }} />

                <div className={classes.dataRow}>
                  <p className={classes.rowKey}>Amount added in Wallet</p>
                  <p className={classes.rowValue}>
                    ₹{' '}
                    {(
                      toNumber(get(selectedSession, 'AMOUNT_ADDED')) / 100
                    ).toFixed(2)}
                  </p>
                </div>

                <div className={classes.dataRow}>
                  <p className={classes.rowKey}>Amount Refunded</p>
                  <p className={classes.rowValue}>
                    ₹{' '}
                    {(
                      toNumber(get(selectedSession, 'AMOUNT_REFUNDED')) / 100
                    ).toFixed(2)}
                  </p>
                </div>

                <div className={classes.dataRow}>
                  <p className={classes.rowKey}>
                    Amount Consumed Exclusive Tax
                  </p>
                  <p className={classes.rowValue}>
                    ₹{' '}
                    {(
                      toNumber(get(selectedSession, 'AMOUNT_CONSUMED')) / 100 -
                      toNumber(get(selectedSession, 'AMOUNT_TAX')) / 100
                    ).toFixed(2)}
                  </p>
                </div>

                <div className={classes.dataRow}>
                  <p className={classes.rowKey}>
                    Tax on Amount Consumed(18.0% GST)
                  </p>
                  <p className={classes.rowValue}>
                    ₹{' '}
                    {(
                      toNumber(get(selectedSession, 'AMOUNT_TAX')) / 100
                    ).toFixed(2)}
                  </p>
                </div>

                <hr style={{ marginTop: '5px', marginBottom: '5px' }} />

                <div className={classes.dataRow}>
                  <p
                    style={{
                      fontWeight: 700,
                      marginBottom: '0px',
                      color: '#8898aa',
                      fontSize: '15px',
                    }}
                  >
                    Net Total
                  </p>
                  <p
                    style={{
                      fontSize: '19px',
                      fontWeight: 800,
                      color: '#4f4f4f',
                      marginBottom: '0px',
                    }}
                  >
                    ₹{' '}
                    {toNumber(
                      get(selectedSession, 'AMOUNT_CONSUMED') / 100,
                    ).toFixed(2)}
                  </p>
                </div>
              </>
            ) : null}
          </>
        )}

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Image
            src={JpLongLogo}
            alt="Joulepoint"
            preview={false}
            className={classes.brandLogo}
          />
        </div>
      </ModalBody>
    </Modal>
  );
}
